import React from 'react';
import PropTypes from 'prop-types';
import {
  Legend,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  BarChart,
  Bar,
} from 'recharts';
import { DateTime } from 'luxon';

const COLORS = [
  '#FF0000',
  '#00B0CA',
  '#C88FCA',
  '#E60000',
  '#007E92',
  '#5E2750',
  '#BD0000',
  '#005765',
  '#5E2750',
  '#990000',
];

export default function StackedBarChartComponent(props) {
  let tooltipHoverKey = null;

  return (
    <div
      className={`StackedBarChartComponent ${props.className || ''}`}
      data-testid="StackedBarChartComponent"
    >
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={props.chartData} margin={{ top: 20, right: 50, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            tickFormatter={(tick) => {
              return tick
                ? !props.xAxis.displayFormat
                  ? tick
                  : DateTime.fromMillis(tick).toFormat(props.xAxis.displayFormat)
                : '';
            }}
          />
          <YAxis />
          {props.customTooltip ? (
            <Tooltip content={(bb) => props.customTooltip(bb, tooltipHoverKey)} />
          ) : (
            <Tooltip contentStyle={tooltipStyle} />
          )}
          <Legend align="left" />
          {props.bars.map((barKey, index) => (
            <Bar
              maxBarSize={30}
              stackId="a"
              name={barKey.name}
              key={`${barKey.key}-${index}`}
              dataKey={barKey.key}
              fill={COLORS[index]}
              onMouseOver={() => (tooltipHoverKey = barKey.name)}
              onMouseOut={() => (tooltipHoverKey = null)}
            ></Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

const tooltipStyle = {
  border: 'none',
  boxShadow: '0px 5px 10px rgba(106, 101, 115, 0.2)',
};

StackedBarChartComponent.propTypes = {
  chartData: PropTypes.array,
  bars: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
  valuePrefix: PropTypes.string,
  customTooltip: PropTypes.func,
};

StackedBarChartComponent.defaultProps = {
  chartData: [],
  bars: [],
  valuePrefix: '',
  xAxis: {},
  yAxis: {},
  customTooltip: null,
};
